import { AlertTriangle } from '@timelyapp/icons/solid-icons';
import { Pill } from '@timelyapp/react';
import Tooltip from 'components/Tooltip';
import React from 'react';
import { formatUtilizationFormula, getUtilizationStatus } from 'utils/utilization';
import { TableWidgetPlaceholderBlock } from './TableWidgetPlaceholderBlock';

interface Props {
  /** Billable time in hours, as reported for the row. */
  billableHours?: number;

  /** Capacity in minutes, as reported for the row. */
  capacity?: number;

  /** Billable time as a percentage of capacity. */
  utilization?: number;
}

const PILL_VARIANTS = {
  'over-capacity': 'danger',
  'on-target': 'success',
  'below-target': 'alert',
} as const;

/**
 * Displays utilization as a pill judged against the utilization target, with the division behind
 * the number in a tooltip so the percentage can be audited.
 */
const TableWidgetUtilizationBlock: React.FC<Props> = ({ billableHours, capacity, utilization }) => {
  if (utilization == null) return <TableWidgetPlaceholderBlock />;

  const status = getUtilizationStatus(utilization);

  return (
    <Tooltip
      position="left"
      title={formatUtilizationFormula(Math.round((billableHours ?? 0) * 60), capacity)}
    >
      <Pill
        size="small"
        variant={PILL_VARIANTS[status]}
        post={status === 'over-capacity' ? <AlertTriangle /> : undefined}
      >
        {utilization}%
      </Pill>
    </Tooltip>
  );
};

export default TableWidgetUtilizationBlock;
